'use client';
import { PAGE_PARAM, SEARCH_PARAM } from '../entryIndexConstants';
import { EntryIndexFilterState, FilterSelections } from '../entryIndexTypes';

export const getStateFromParams = (
  maybeSearchParams: URLSearchParams | null,
  filterIds: string[]
): EntryIndexFilterState => {
  const searchParams = maybeSearchParams ?? new URLSearchParams();

  // Get the search parameter - URLSearchParams.get() should automatically decode
  // However, in some cases with Next.js, values might need additional handling
  let search = searchParams.get(SEARCH_PARAM);
  
  // Ensure proper decoding for non-ASCII characters
  // URLSearchParams should handle this, but we add a safety check for edge cases
  if (search) {
    // Check if the value appears to be URL-encoded but wasn't decoded by URLSearchParams
    // This can happen in some edge cases with non-ASCII characters
    try {
      // If the string contains % encoding patterns, try decoding it
      // This handles cases where the value might be partially encoded
      if (/%[0-9A-Fa-f]{2}/.test(search)) {
        const decoded = decodeURIComponent(search);
        // Only use decoded if it successfully decoded and is different
        if (decoded && decoded !== search) {
          search = decoded;
        }
      }
    } catch {
      // If decoding fails, the value is likely already properly decoded
      // Keep the original value from URLSearchParams
    }
  }

  const page = parseInt(searchParams.get(PAGE_PARAM) ?? '1', 10);

  const filterSelections = filterIds.reduce<FilterSelections>((acc, filterId) => {
    const values = searchParams.getAll(filterId);
    if (values.length) {
      acc[filterId] = values;
    }
    return acc;
  }, {});

  return { filterSelections, page, search };
};
